import { ATTRIBUTION_KEY } from './storageKeys';

export interface Attribution {
  source?: string;
  medium?: string;
  campaign?: string;
  content?: string;
  src?: string;
  ref?: string;
  referrer?: string;
  landing_path?: string;
  demo_src?: string;
  captured_at: string;
}

const MAX = 80;
const corta = (v: string | null) => (v ? v.slice(0, MAX) : undefined);

export function captureAttribution(search: string, pathname: string): void {
  try {
    const q = new URLSearchParams(search);
    const previo = sessionStorage.getItem(ATTRIBUTION_KEY);
    if (previo) {
      // El primer origen se conserva; si después pasa por la demo, se anota.
      if (q.get('utm_source') === 'demo') {
        const datos = JSON.parse(previo) as Attribution;
        datos.demo_src = corta(q.get('utm_campaign')) || 'directo';
        sessionStorage.setItem(ATTRIBUTION_KEY, JSON.stringify(datos));
      }
      return;
    }
    const referrer = document.referrer || '';
    const propio = referrer.includes('app.guidemeapp.es') || referrer.startsWith(window.location.origin);
    const datos: Attribution = {
      source: corta(q.get('utm_source')),
      medium: corta(q.get('utm_medium')),
      campaign: corta(q.get('utm_campaign')),
      content: corta(q.get('utm_content')),
      src: corta(q.get('src')),
      ref: corta(q.get('ref')),
      referrer: propio ? undefined : corta(referrer.slice(0, 200)),
      landing_path: corta(pathname),
      captured_at: new Date().toISOString(),
    };
    const hayAlgo = Object.entries(datos).some(([k, v]) => k !== 'captured_at' && k !== 'landing_path' && v);
    if (!hayAlgo && !referrer) {
      datos.source = 'directo';
    }
    sessionStorage.setItem(ATTRIBUTION_KEY, JSON.stringify(datos));
  } catch {
    /* sin storage, sin atribución */
  }
}

export function getAttribution(): Attribution | null {
  try {
    const raw = sessionStorage.getItem(ATTRIBUTION_KEY);
    return raw ? (JSON.parse(raw) as Attribution) : null;
  } catch {
    return null;
  }
}
